<div>
    <mat-dialog-content class="dialog-content">
        <div class="modal-title d-flex justify-content-center header-bottom-class">
            <span>Session expired</span>
        </div>
        <img src="assets/icons/icon_session.svg" alt="session expired">
        <p class="bodyText text-center mb-0">Your session has expired. Please login again.</p>
        <div>
            <div class="d-flex justify-content-center align-items-center">
                <button mat-raised-button class="primary-button" mat-dialog-close cdkFocusInitial
                    (click)="actionFunction()">
                    Login again
                </button>
            </div>
        </div>
    </mat-dialog-content>
</div>
